<template>
  <div class="main-content">
    <el-row>
      <el-col :span="16">
        <el-button type="primary" @click="toAddJob"><i class="el-icon-plus"></i>发布职位</el-button>
      </el-col>
      <el-col :span="8" style="text-align:right; line-height:40px;">
        <el-input placeholder="输入职位名搜索" size="medium" v-model="searchKey" class="job-input-search" @change="getJobList"
          suffix-icon="el-icon-search">
        </el-input>
        <el-dropdown @command="onPostStateChange">
          <span class="el-dropdown-link">
            {{postStateText}}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="online">招聘中职位</el-dropdown-item>
            <el-dropdown-item command="offline">已下线职位</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-col>
    </el-row>
    <div class="job-list-wrap">
      <ul>
        <li class="job-item" v-for="(item) in jobs" :key="item.post_id">
          <el-row>
            <el-col :span="16" class="job-info">
              <router-link :to="{name:'JobEdit', query: {id: item.post_id}}">
                <span class="job-info-title"> {{item.post_name}}</span>
                <el-tag v-if="item.job_nature_id==12">{{item.job_nature}}</el-tag>
              </router-link>
              
              <p class="info-labels">{{item.address}}<el-divider direction="vertical"></el-divider>{{item.post_salary}}
              <span v-if="item.hire_start_date"><el-divider direction="vertical"/>{{formatDate(item.hire_start_date)}} - {{formatDate(item.hire_end_date)}}(共{{getDays(item)}}天)</span>
              </p>
            </el-col>
            <el-col :span="4" class="date-wrap">
              <span class="date">发布时间：{{$Shared.formatDate(item.refreshDate)}}</span>
            </el-col>
            <el-col :span="4" class="opration-wrap">
              <el-link v-if="item.post_state === 1" :href="'#/JobEdit?id=' + item.post_id" type="primary" :underline="false">编辑</el-link>
              <el-link v-if="item.post_state === 1" type="primary" :underline="false" @click="onRefresh(item.post_id)">刷新</el-link>
              <el-link v-if="item.post_state === 1" type="primary" :underline="false" @click="handelOffline(item.post_id)">下线</el-link>
              <el-link v-if="item.post_state === 2" type="primary" :underline="false" @click="onDelete(item.post_id)">删除</el-link>
              <el-link v-if="item.post_state === 2" type="primary" :underline="false" @click="handelOnline(item.post_id)">上线</el-link>
            </el-col>
          </el-row>
        </li>
      </ul>
      <div class="nomore" v-if="!loading && jobs.length === 0">当前没有更多职位</div>
    </div>
  </div>
</template>

<script>
  import {
    getJobList, online, offline, deleteJob, refresh
  } from '~/api/job';
  export default {
    data() {
      return {
        searchKey: '',
        allJobs: [],
        jobs: [],
        postState: 1,
        postStateText: '招聘中职位',
        loading: false,
      };
    },
    created() {
      this.$emit('changeMenu', 'JobIndex');   
    },
    mounted(){
      this.getJobList();
    },
    methods: {      
      formatDate(date) {
        return this.$Shared.formatDate(date);
      },
      getDays(item){
        if(item.hire_start_date){
          let s1 = new Date(item.hire_start_date);
          let s2 = new Date(item.hire_end_date);//
          var times = s2.getTime() - s1.getTime();
          var days = parseInt(times / (1000 * 60 * 60 * 24));
          return isNaN(days)?0:days+1;
        }else{
          return '';
        }
      },

      getJobList() {
        var params = {
          job_name: this.searchKey
        };
        this.loading = true;
        const loadingMask = this.$loading({
          lock: true,
          text: '加载中...',
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0.7)',
          target: document.querySelector('.job-list-wrap')
        });
        getJobList(params).then(m => {
          this.loading = false;
          loadingMask.close();
          if (m.errcode == 0) {
            let datas = m.data;
            this.allJobs = datas;
            this.jobs = this.allJobs.filter(job => job.post_state === this.postState);
          }
        }).catch( ex => {
          this.loading = false;
          loadingMask.close();
          this.$message.error(ex);
        });
      },
      onPostStateChange(val){
        if(val === 'online'){
          this.postState = 1;
          this.postStateText = '招聘中职位';
        } else if(val === 'offline'){
          this.postState = 2;
          this.postStateText = '已下线职位';
        }
        this.getJobList();
      },
      toAddJob(){
        this.$router.push('/JobEdit');
      },
      handelOffline(jobId){
        this.$confirm('确定下线该职位吗？').then( () => {
          var params = {
            job_id: jobId
          };
          offline(params).then( m => {
            if(m.errcode === 0){
              this.getJobList();
            } else {
              this.$message.error(m.errmsg);
            }
          });
        }).catch();
      },
      handelOnline(jobId){this.$confirm('确定上线该职位吗？').then( () => {
        var params = {
          job_id: jobId
        };
        online(params).then( m => {
          if(m.errcode === 0){
            this.getJobList();
          } else {
            this.$message.error(m.errmsg);
          }
        });
      }).catch();
      },
      onRefresh(jobId){
        this.$confirm('刷新职位后人才端职位会靠前显示，同时扣除一个职位数，确定刷新？').then(() => {
          var params = {
            post_id: jobId
          };
          refresh(params).then( r => {
            if(r.errcode === 0){
              this.$message.success('职位刷新成功');
              this.getJobList();
            } else {
              this.$message.error('职位刷新失败，原因' + r.errmsg);
            }
          });
        }).catch(() => {
        });        
      },
      onDelete(jobId){
        this.$confirm('确定删除职位？').then(() => {
          var params = {
            job_id: jobId
          };
          deleteJob(params).then( r => {
            if(r.errcode === 0){
              this.getJobList();
            } else {
              this.$message.error('职位删除失败，原因' + r.errmsg);
            }
          });
        }).catch(() => {
        });        
      },
    }
  };
</script>

<style scoped>
  .main-content {
    text-align: left;
  }

  .job-input-search {
    width: 260px;
    margin-right: 20px;
  } 

  .nomore{
    padding: 30px;
  }
</style>